export default __webpack_public_path__ + "static/Placeholders-5b1a42097f1b9d363d48c30ca90fbcc2.png";